"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UnityLoaderService = /** @class */ (function () {
    function UnityLoaderService() {
        /**
         * A reference to the document head.
         * @type {HTMLHeadElement}
         */
        this.documentHead = document.querySelector("head");
    }
    /**
     * Appends the Unity loader script to the window. When a version of the loader
     * is already appended, we'll skip right away. When another loader is try to
     * append, the previous will be removed first.
     * @param {string} url the path to the Unity loader file
     * @param {Function} onLoad when the script is loaded
     * @returns A promise when resolving when the file is loaded.
     */
    UnityLoaderService.prototype.load = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (typeof _this.unityLoaderScript !== "undefined")
                if (url === _this.unityLoaderScript.src) {
                    return resolve();
                }
                else {
                    _this.unityLoaderScript.remove();
                }
            _this.unityLoaderScript = document.createElement("script");
            _this.unityLoaderScript.type = "text/javascript";
            _this.unityLoaderScript.async = true;
            _this.unityLoaderScript.src = url;
            _this.unityLoaderScript.onload = function () { return resolve(); };
            _this.unityLoaderScript.onerror = function () { return reject("Unable to load " + url); };
            _this.documentHead.appendChild(_this.unityLoaderScript);
        });
    };
    return UnityLoaderService;
}());
exports.default = UnityLoaderService;
//# sourceMappingURL=unityLoaderService.js.map